import { printHTML } from "hooks/utils/formatter";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";

const Categories = ({ attrs }) => {
  const block_data = attrs?.data;

  return (
    <section className="px-4 mx-auto mb-16 overflow-hidden md:mb-20 xl:px-0 max-w-app">
      <div className="col-span-12 md:col-span-9 md:col-start-2">
        <h1>{printHTML(block_data?.titel)}</h1>
        <div className="max-w-xl mb-8 text-paragraph leading-[1.375rem]">
          {printHTML(block_data?.korte_omschrijving)}
        </div>

        <Swiper
          slidesPerView={"auto"}
          breakpoints={{ 0: { spaceBetween: 16 }, 768: { spaceBetween: 48 } }}
          className="!overflow-visible category_swiper"
        >
          {block_data?.selecteer_categorie?.map((categorie) => {
            const imgUrl = categorie?.thumbnail?.url;

            const alt =
              categorie?.thumbnail?.alt || categorie?.title || "";

            return (
              <SwiperSlide
                className="md:!w-[calc((1200px-(48px*4))/5)] !w-32"
                key={categorie?.title}
              >
                <a
                  className="flex flex-col gap-2 no-underline group md:gap-4"
                  href={categorie?.permalink}
                  title={categorie?.title}
                >
                  <div className="flex flex-col items-center aspect-square">
                    <div className="relative flex items-center justify-center w-full h-full rounded bg-light_grey group-hover:bg-[#EFE9EB] transition-all duration-300">
                      <div className="relative w-32 h-24 md:h-32">
                        {imgUrl && (
                          <Image
                            src={imgUrl}
                            alt={alt}
                            className="object-contain transition-all duration-300 group-hover:scale-105"
                            fill
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center font-bold text-13 md:text-15 text-dark-text">
                    {categorie?.title}
                  </div>
                </a>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};

export default Categories;
